import { render, staticRenderFns } from "./VMapBox.vue?vue&type=template&id=6fc6c664"
import script from "./VMapBox.vue?vue&type=script&lang=js"
export * from "./VMapBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports